const versionsPath = (segment, entityId, at) => {
    const base = `/v1/food-catalog/${segment}/${encodeURIComponent(entityId)}/versions`;
    return at !== undefined ? `${base}?at=${encodeURIComponent(at)}` : base;
};
export class FoodCatalogApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Publish an immutable, effective-dated menu version (append-only; a colliding version is 409). */
    publishMenuVersion(menuId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-catalog/menus/${encodeURIComponent(menuId)}/versions`, body: input, auth: true });
    }
    /** Publish an immutable, effective-dated category version (append-only; a colliding version is 409). */
    publishCategoryVersion(categoryId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-catalog/categories/${encodeURIComponent(categoryId)}/versions`, body: input, auth: true });
    }
    /** Publish an immutable, effective-dated item version carrying the base price (append-only; a colliding version is 409). */
    publishItemVersion(itemId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-catalog/items/${encodeURIComponent(itemId)}/versions`, body: input, auth: true });
    }
    /** A menu's version history, or — with `at` — the single version effective at that UTC instant. */
    listMenuVersions(menuId, at) {
        return this.client.request({ method: 'GET', path: versionsPath('menus', menuId, at), auth: true });
    }
    /** A category's version history, or — with `at` — the single version effective at that UTC instant. */
    listCategoryVersions(categoryId, at) {
        return this.client.request({ method: 'GET', path: versionsPath('categories', categoryId, at), auth: true });
    }
    /** An item's version history, or — with `at` — the single version effective at that UTC instant. */
    listItemVersions(itemId, at) {
        return this.client.request({ method: 'GET', path: versionsPath('items', itemId, at), auth: true });
    }
    /** Set an item's availability (sold-out + weekly open schedule); a stale/concurrent write is 409. */
    setItemAvailability(itemId, input) {
        return this.client.request({ method: 'PUT', path: `/v1/food-catalog/items/${encodeURIComponent(itemId)}/availability`, body: input, auth: true });
    }
    /** Read an item's current availability (404 when never set). */
    getItemAvailability(itemId) {
        return this.client.request({ method: 'GET', path: `/v1/food-catalog/items/${encodeURIComponent(itemId)}/availability`, auth: true });
    }
    /** D394: a store's effective menu for its merchant (404 when the store sells no menu). */
    storeMenu(locationId) {
        return this.client.request({ method: 'GET', path: `/v1/food-catalog/stores/${encodeURIComponent(locationId)}/menu`, auth: true });
    }
    /** D394: the merchant's text-only edit — a new version effective now, reason-coded and audited. */
    editItem(itemId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-catalog/items/${encodeURIComponent(itemId)}/edit`, body: input, auth: true });
    }
    /** D394: switch an item sold out (or back), keeping its schedule; `changed: false` when it already was. */
    setItemSoldOut(itemId, soldOut) {
        return this.client.request({ method: 'POST', path: `/v1/food-catalog/items/${encodeURIComponent(itemId)}/sold-out`, body: { soldOut }, auth: true });
    }
    // ---- W9-MERCHANT-CONSOLE (D480, ADR-0098; M-13, G-047, G-051): the merchant creates its own catalog ---------------------------------
    /** Create a category in the store's menu (the menu's next version links it). */
    createCategory(locationId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-catalog/stores/${encodeURIComponent(locationId)}/categories`, body: input, auth: true });
    }
    /**
     * D854 (L3-026): take an EMPTY category off the store's menu (the menu's next version stops listing it; nothing is deleted). A category that still
     * holds an item is refused `409 CATEGORY_NOT_EMPTY`.
     */
    archiveCategory(locationId, categoryId) {
        return this.client.request({ method: 'POST', path: `/v1/food-catalog/stores/${encodeURIComponent(locationId)}/categories/${encodeURIComponent(categoryId)}/archive`, auth: true });
    }
    /** Create an item in one of the store's categories (priced in the menu's currency; the category's next version links it). */
    createItem(locationId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-catalog/stores/${encodeURIComponent(locationId)}/items`, body: input, auth: true });
    }
    /** The merchant's effective complement groups. */
    modifierGroups(locationId) {
        return this.client.request({ method: 'GET', path: `/v1/food-catalog/stores/${encodeURIComponent(locationId)}/modifier-groups`, auth: true });
    }
    createModifierGroup(locationId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-catalog/stores/${encodeURIComponent(locationId)}/modifier-groups`, body: input, auth: true });
    }
    /** Edit a group as its next version (`expectedVersion` = the version read; a stale one is `409 STALE_VERSION`). */
    editModifierGroup(groupId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-catalog/modifier-groups/${encodeURIComponent(groupId)}/versions`, body: input, auth: true });
    }
    /** Link / unlink an item's complement groups as the item's next version. */
    setItemModifierGroups(itemId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-catalog/items/${encodeURIComponent(itemId)}/modifier-groups`, body: input, auth: true });
    }
}
//# sourceMappingURL=food-catalog.js.map